// реально any
/* eslint-disable @typescript-eslint/no-explicit-any */
export function noopReducer(defaults: any = null) {
  return (state: any) => state || defaults;
}
